/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type EnableTenantDestinationRequest = {
  /**
   * The ID of the tenant. Required when using AdminApiKey authentication.
   */
  tenantId: string;
  /**
   * The ID of the destination.
   */
  destinationId: string;
};

/** @internal */
export const EnableTenantDestinationRequest$inboundSchema: z.ZodType<
  EnableTenantDestinationRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  tenant_id: z.string(),
  destination_id: z.string(),
}).transform((v) => {
  return remap$(v, {
    "tenant_id": "tenantId",
    "destination_id": "destinationId",
  });
});
/** @internal */
export type EnableTenantDestinationRequest$Outbound = {
  tenant_id: string;
  destination_id: string;
};

/** @internal */
export const EnableTenantDestinationRequest$outboundSchema: z.ZodType<
  EnableTenantDestinationRequest$Outbound,
  z.ZodTypeDef,
  EnableTenantDestinationRequest
> = z.object({
  tenantId: z.string(),
  destinationId: z.string(),
}).transform((v) => {
  return remap$(v, {
    tenantId: "tenant_id",
    destinationId: "destination_id",
  });
});

export function enableTenantDestinationRequestToJSON(
  enableTenantDestinationRequest: EnableTenantDestinationRequest,
): string {
  return JSON.stringify(
    EnableTenantDestinationRequest$outboundSchema.parse(
      enableTenantDestinationRequest,
    ),
  );
}
export function enableTenantDestinationRequestFromJSON(
  jsonString: string,
): SafeParseResult<EnableTenantDestinationRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EnableTenantDestinationRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EnableTenantDestinationRequest' from JSON`,
  );
}
